import { render, staticRenderFns } from "./groupPanel.vue?vue&type=template&id=5fca5686&scoped=true"
import script from "./groupPanel.vue?vue&type=script&lang=js"
export * from "./groupPanel.vue?vue&type=script&lang=js"
import style0 from "./groupPanel.vue?vue&type=style&index=0&id=5fca5686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca5686",
  null
  
)

export default component.exports